// extracted by mini-css-extract-plugin
export default {"container":"Form_container__VnWkw","button":"Form_button__DR68D","form":"Form_form__hIxy4"};